import { SelectFormField } from "@duosoftbg/nacid-components";
import { useEffect } from "react";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { arUniStatusesThunk } from "../../../../../store/redux/slice/AppData/arUniStatuses";

const ARUniRecognitionStatusSelectField = ({ labelCode, fieldName, required, allowedValues = null }) => {
  const dispatch = useAppDispatch();
  const statusesThunkState = useAppSelector((state) => {
    return state.AppData.arUniStatuses;
  });

  useEffect(() => {
    dispatch(arUniStatusesThunk());
  }, [dispatch]);

  return (
    <SelectFormField
      required={required}
      addEmptyOption={true}
      onlyActive={true}
      labelCode={labelCode}
      fieldName={fieldName}
      selectOptions={
        statusesThunkState.data
          ? statusesThunkState.data
              .filter((st) => !allowedValues || allowedValues.filter((val) => val === st.id).length > 0)
              .map((st) => {
                return { value: st.id, text: st.name, active: st.isActive };
              })
          : []
      }
    />
  );
};
export default ARUniRecognitionStatusSelectField;
